/**
 * Mixin de detecção de viewport mobile.
 *
 * Usa matchMedia (com fallback para o evento resize em browsers antigos) e
 * expõe `isMobile` como dado reativo, para que as telas possam renderizar
 * um layout alternativo em vez de apenas esconder colunas via CSS.
 *
 * Breakpoint: 767.98px (equivalente ao "md" do Bootstrap 5).
 */

export const MOBILE_MEDIA_QUERY = '(max-width: 767.98px)'

export default {
  data() {
    return {
      isMobile: typeof window !== 'undefined'
        ? window.matchMedia(MOBILE_MEDIA_QUERY).matches
        : false,
      mobileMediaQueryList: null,
    }
  },

  created() {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return
    }

    this.mobileMediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY)
    this.isMobile = this.mobileMediaQueryList.matches

    if (this.mobileMediaQueryList.addEventListener) {
      this.mobileMediaQueryList.addEventListener('change', this.onMobileMediaChange)
    } else {
      // Safari < 14
      this.mobileMediaQueryList.addListener(this.onMobileMediaChange)
    }
  },

  beforeUnmount() {
    if (!this.mobileMediaQueryList) {
      return
    }

    if (this.mobileMediaQueryList.removeEventListener) {
      this.mobileMediaQueryList.removeEventListener('change', this.onMobileMediaChange)
    } else {
      this.mobileMediaQueryList.removeListener(this.onMobileMediaChange)
    }

    this.mobileMediaQueryList = null
  },

  methods: {
    onMobileMediaChange(event) {
      this.isMobile = event.matches
    },
  },
}
